import axios from 'axios';
import httpClient from './httpClient';
import store from 'redux/configureStore';

/*function getDecorator(url, token) {
    return axios({
        url: url,
        method: 'get',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-AUTH-TOKEN': `${token}`,
        },
        credentials: 'same-origin',
    }).then((res) => res.data);
}*/

export const refreshFile = (html) => {
    return axios.post('http://localhost:3000/server/', {html});
};

export const changeTimezone = (params) => {
    return httpClient
        .patch('/api/v2/account/change_timezone', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getUserTimezones = () => {
    return httpClient
        .get('/api/v2/profile/get_timezone')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getPermissions = () => {
    return httpClient
        .get('/api/v2/profile/get_permissions')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const resetOldPassword = (params) => {
    return httpClient
        .post('/api/v2/profile/refresh_password', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.message;
        });
};

export const refreshApiToken = (params) => {
    return httpClient
        .patch('/api/v2/profile/refresh_token', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.message;
        });
};

export const securityCreateToken = (params) => {
    return httpClient
        .post('/api/v2/security/get_token', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};


export const makeLogout = () => {
    const accessToken = store.getState().auth.wsseToken.accessToken;
    return httpClient
        .post('/api/v2/security/logout', {accessToken})
        .then((res) => res.data)
        .catch((e) => {
            throw e.message;
        });
};



//------------FEEDS---------------

export const getSource = (id) => {
    return httpClient
        .get(`/api/v2/source/${id}?itemsOnPage=100`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteFeed = (id) => {
    return httpClient
        .delete(`/api/v2/source/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getRssLink = (id) => {
    return httpClient
        .get(`/api/v2/source/${id}/rss_link`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getYoutubeCreationPreview = (params) => {
    return httpClient
        .post(`/api/v2/youtube/preview`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const createYoutubeFeed = (params) => {
    return httpClient
        .post(`/api/v2/youtube/create`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getInstagramCreationPreview = (params) => {
    return httpClient
        .post(`/api/v2/instagram/preview`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const createInstagramFeed = (params) => {
    return httpClient
        .post(`/api/v2/instagram/create`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getRssCreationPreview = (params) => {
    return httpClient
        .post(`/api/v2/rss/preview`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const createRssFeed = (params) => {
    return httpClient
        .post(`/api/v2/rss/create`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const toggleAlertStatus = (id) => {
    return httpClient
        .get(`/api/v2/resources/${id}/mail-alert-status`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content.message;
        });
};

export const deleteEntity = (id) => {
    return httpClient
        .delete(`/api/v2/entity/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteSourceFromEntity = (entityId, sourceId) => {
    return httpClient
        .get(`/api/v2/entity/${entityId}/${sourceId}/remove`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};


export const getCategories = () => {
    return httpClient
        .get('/api/v2/search_feed/get_admin_categories')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};



export const getEntityPreview = (params) => {
    return httpClient
        .post('/api/v2/entity/preview', params)
        // .post('/api/v2/companies/get_preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getEditEntityPreview = (id) => {
    return httpClient
        .get(`/api/v2/entity/${id}/edit`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const submitEntityCreation = (params) => {
    const {companyId} = params;
    return httpClient
        .patch(`/api/v2/entity/${companyId}/save`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const submitEntityUpdate = (params) => {
    const {entityId} = params;
    return httpClient
        .patch(`/api/v2/entity/${entityId}/save`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getRssPreviewForEntity = (params) => {
    const {entityId} = params;
    return httpClient
        .post(`/api/v2/entity/${entityId}/add_rss`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getYoutubePreviewForEntity = (params) => {
    const {entityId} = params;
    return httpClient
        .post(`/api/v2/entity/${entityId}/add_youtube`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getInstagramPreviewForEntity = (params) => {
    const {entityId} = params;
    return httpClient
        .post(`/api/v2/entity/${entityId}/add_instagram`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getGoogleNewsPreviewForEntity = (params) => {
    const {entityId} = params;
    return httpClient
        .post(`/api/v2/entity/${entityId}/add_google_news`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getFacebookPreviewForEntity = (params) => {
    const {entityId} = params;
    return httpClient
        .post(`/api/v2/entity/${entityId}/add_facebook`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const updateCompanyFilters = (id, params) => {
    return httpClient
        .post(`/api/v2/companies/${id}/update_filters`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const updateSourceIsOpen = (params) => {
    const {entityId, sourceId} = params;
    return httpClient
        .patch(`/api/v2/entity/${entityId}/${sourceId}/accordion_update`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const updateCompanySorting = (id, params) => {
    return httpClient
        .post(`/api/v2/companies/${id}/update_sorting`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getWebSiteForEntity = (params) => {
    const {entityId} = params;
    return httpClient
        .post(`/api/v2/entity/${entityId}/get_web_source`, params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getWebPreviewForEntity = (params) => {
    const {entityId} = params;
    console.log(params)
    return httpClient
        .post(`/api/v2/entity/${entityId}/get_web_preview`, params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getWebNewsForAddingToEntity = (params) => {
    const {entityId} = params;
    return httpClient
        .post(`/api/v2/entity/${entityId}/add_web`, params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

// --------- TWITTER -------------

export const getTwitterPreview = (params) => {
    return httpClient
        .post('/api/v2/twitter/preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const createTwitterFeed = (params) => {
    return httpClient
        .post('/api/v2/twitter/create', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

// export const getTwitterPreviewForOrg = (params) => {
//     return httpClient
//         .post('/api/v2/twitter/preview', params)
//         .then((res) => res.data)
//         .catch((e) => {
//             throw e.response.data.content;
//         });
// };

export const getTwitterPreviewForEntity = (params) => {
    const {entityId} = params;
    return httpClient
        .post(`/api/v2/entity/${entityId}/add_twitter`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};


//--------------WEB-------------------

export const createWebFeed = (params) => {
    return httpClient
        .post('/api/v2/web/create', params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getNewsPreview = (params) => {
    console.log(params);
    return httpClient
        .post('/api/v2/web/get_preview', params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getOriginalSite = (params) => {
    return httpClient
        .post('/api/v2/web/get_resource', params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getResourceById = (id, discriminator) => {
    return httpClient
        .get(`/api/v2/resources/${discriminator}/${id}`)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

//-------------FACEBOOK---------------

export const facebookLogout = (params) => {
    return httpClient
        .post('/api/v2/facebook/logout', params)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getFacebookUrl = () => {
    return httpClient
        .get('/api/v2/facebook/login')
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getDataForFacebookAutocomplete = (params) => {
    return httpClient
        .post('/api/v2/entity/find_facebook_page', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getFacebookPreview = (feedId, params) => {
    // if(feedId) {
    //     return httpClient
    //         .post(`/api/v2/facebook/preview/${feedId}`, params)
    //         .then((res) => res.data)
    //         .catch((e) => {
    //             throw e.response.data.content;
    //         })
    // } else {
    return httpClient
        .post('/api/v2/facebook/preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
    //}
};

export const createFacebookFeed = (params) => {
    return httpClient
        .post('/api/v2/facebook/create', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getFacebookPreviewForOrg = (params) => {
    return httpClient
        .post('/api/v2/companies/add_facebook/get_preview', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getCompaniesFbAutocomplete = (params) => {
    return httpClient
        .post('/api/v2/companies/facebook_find_pages', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

//-------------LINKEDIN---------------

export const linkedinLogin = () => {
    return httpClient
        .get('/api/v2/free/linkedin/login')
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

//-------------FEEDREADER---------------

export const getFeedsForFeedreader = () => {
    return httpClient
        .get('/api/v2/reader?itemsOnPage=1000')
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const getNewsByIdForFeedreader = (id, query) => {
    return httpClient
        .get(`/api/v2/reader/${id + query}`)
        .then((res) => res.data.content)
        .catch((err) => {
            throw err.response.data.content;
        });
};

export const toggleSavedSearchesDailyAlerts = (id) => {
    return httpClient
        .get(`/api/v2/search_feed/${id}/mail-alert-status`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const toggleSavedSearchesRealtimeAlerts = (id) => {
    return httpClient
        .get(`/api/v2/search_feed/${id}/hourly-mail-alert-status`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const assignAlertToUsers = (sourceId, users, alertType) => {
    let baseStr = '';
    users.length > 0 && users.map(id => {
        return baseStr += `&users%5B%5D=${id}`;
    });
    let url = `/api/v2/source/${sourceId}/add_alert?${baseStr}&type=${alertType}`;
    return httpClient
        .get(url)
        .then((res) => res.data)
        .catch((e) => {
            console.log(e);
            throw e.response.data.content;
        });
};



//-------------USERS---------------



export const getUsersForAlerts = () => {
    return httpClient
        .get('/api/v2/account/user_list')
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const addUser = (params) => {
    return httpClient
        .post('/api/v2/account/add_user', params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const deleteUser = (id) => {
    return httpClient
        .delete(`/api/v2/profile/${id}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const editUser = (id, params) => {
    return httpClient
        .patch(`/api/v2/account/${id}/edit_user`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const assignDailySearchesToUser = (id, params) => {
    return httpClient
        .patch('/api/v2/corporate/assign_alerts/' + id, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const assignRTSearchesToUser = (id, params) => {
    return httpClient
        .patch('/api/v2/corporate/assign_alerts/' + id, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

